import { BranchSwitcher } from "./BranchSwitcher";
import { useAuth } from "@/contexts/AuthContext";

export function GymInfo() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3 md:justify-between">
      <div className="min-w-0 shrink">
        <div className="min-w-0 truncate text-sm font-semibold leading-tight text-foreground sm:text-[15px]">
          <span className="block truncate">
            {user.firstName} {user.lastName}
          </span>
        </div>
        <p className="truncate text-[11px] leading-tight text-muted-foreground sm:text-[12px]">
          {user.role}
        </p>
      </div>
      <div className="min-w-[112px] max-w-[132px] shrink-0 sm:w-[220px] sm:min-w-[180px] sm:max-w-[220px] md:min-w-[220px]">
        <BranchSwitcher />
      </div>
    </div>
  );
}
